import React from 'react';

import { BookLayoutEnum } from '~/api/book/bookApiTypes';
import { SCCatalogGrid, SCCatalogList } from '~/atomic/page/catalog/styled';
import { CSSSkeleton } from '~/atomic/page/index/styled';
import { catalogBookLayoutSelector } from '~/feature/catalog/CatalogBookLayout/catalogBookLayout.selector';
import { useAppSelector } from '~/store';

export const CatalogSkeleton = ({
  isShow, count = 24, gridCount = 6, layout: layoutFromProps,
}: { isShow: boolean, count?: number, gridCount?: number; layout?: BookLayoutEnum }) => {
  const { layout: layoutFromState } = useAppSelector(catalogBookLayoutSelector);
  const layout = layoutFromProps ?? layoutFromState;

  if (!isShow) return null;

  if (layout === BookLayoutEnum.LIST) {
    return (
      <SCCatalogList>
        {Array(count)
          .fill('dummy')
          .map((dummy, index) => (
            <CSSSkeleton key={index} active />
          ))}
      </SCCatalogList>
    );
  }

  return (
    <SCCatalogGrid style={{ ['--items-count' as any]: gridCount }}>
      {Array(count)
        .fill('dummy')
        .map((dummy, index) => (
          <CSSSkeleton key={index} active />
        ))}
    </SCCatalogGrid>
  );
};
